import React, { useEffect, useState, useRef } from "react";
import { Button, Card, Col, Form, Input, Popconfirm, Row, Select, SelectProps, Space, Tooltip, Modal, DatePicker } from "antd";
import { useParams } from "react-router-dom";
import HTTPService from "../../../utils/makerequest";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { IPageProps } from "../../../interfaces/page-data";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";
import { IInventory } from "../../../interfaces/IItemData";
import { useTranslation } from "react-i18next";
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined, UnorderedListOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import { Box, Tab, Tabs } from "@material-ui/core";
import LaborTask from "./Modal/LaborTask";
import { Toast } from 'primereact/toast';
import { FormInstance } from "antd/lib/form";
import AddActivityName from "./AddActivityName";
import { IUser } from "../../../interfaces/IUser";
import Dropdown from "../../../AltisComponent/Dropdown";

const AddFault: React.FunctionComponent<IPageProps> = (props) => {
    const { maintenanceId } = useParams<any>();
    const [careData, setCareData] = useState<any>();
    const [companyData, setCompanyData] = useState<ICompanyData[]>();
    const [selectedCompany, setSelectedCompany] = useState<number | undefined>(undefined);
    const [activityData, setActivityData] = useState<any>();
    const [inventoryData, setInventoryData] = useState<IInventory>();
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [selectedActivityType, setSelectedActivityType] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [maintenanceType, setMaintenanceType] = useState<number>();
    const [isModalVisibleFault, setIsModalVisibleFault] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const { t } = useTranslation();
    const toast = useRef<Toast>(null);
    const [form] = Form.useForm();
    const [showCustomFrequency, setShowCustomFrequency] = useState(false);
    const [selectedActivity, setSelectedActivity] = useState<number | undefined>(form.getFieldValue('activityId'));
    const [userData, setUserData] = useState<IUser[]>();

    useEffect(() => {
        props.onSetPage({
            title: t('maintenanceAndFaiuure')
        });

        InventoryFilter();
        fetchData();
        fetchActivity(userInfo?.companyId);
        getUserData(userInfo?.companyId);

        if (maintenanceId && parseInt(maintenanceId) !== 0) {
            getCareId(parseInt(maintenanceId));
        } else {
            setCareData({
                repeatMaintenanceTBL: [],
                count: 0
            });
        }
    }, []);

    useEffect(() => {
        setShowCustomFrequency(form.getFieldValue('repeatActivity') === 'Custom');
    }, [form.getFieldValue('repeatActivity')]);

    const fetchData = async () => {
        const result = await HTTPService.GETCompanyNames();
        setCompanyData(result);
    };

    const handleMaintenanceTypeChange = (value: number) => {
        setMaintenanceType(value);
    };

    const getUserData = (companyId: number) => {
        HTTPService.GET(`/User/allUserName?companyId=${companyId}`)
            .then((res) => {
                if (!res.data) {
                    return;
                }
                if (res.status === 200) {
                    setUserData(res.data);
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: res.error.message,
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    };


    const savedNewFault = async (newActivity: any) => {
        try {
            setActivityData(prevData => {
                const updatedData = prevData ? [...prevData] : [];
                updatedData.push(newActivity);
                return updatedData;
            });

            form.setFieldValue('activityId', newActivity.activityId);
            setSelectedActivity(newActivity.activityId);

            setIsModalVisibleFault(false);

            toast.current?.show({
                severity: 'success',
                summary: t('success'),
                detail: t('activity_added_successfully'),
                life: 3000
            });
        } catch (error) {
            console.error('Error saving activity:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_saving_activity'),
                life: 3000
            });
        }
    };

    const getCareId = (maintenanceId: number) => {
        HTTPService.GET(`/Maintenance/MaintenanceById?maintenanceId=${maintenanceId}`)
            .then((res) => {
                if (res.status === 200 && res.data) {
                    setCareData(res.data);
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: res.error?.message || t('error_fetching_data'),
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('error_fetching_data'),
                    life: 3000
                });
                console.error("Error fetching brand data:", error);
            });
    };

    const columns: IMUIDataGridColumns[] = [
        ...(userInfo.role !== UserRole.Admin
            ? [
                {
                    title: t('Company Name'),
                    key: 'companyName',
                    placeHolder: t('Company Name'),
                    isSorting: true,
                },
            ]
            : []),
        {
            title: t('inventoryName'),
            headerAlign: 'center',
            align: 'left',
            key: 'inventoryName',
            placeHolder: t('inventoryName'),
            width: 250
        },
        {
            title: t('barcode'),
            isSorting: true,
            key: 'barcode',
            placeHolder: t('barcode'),
            width: 250
        },
        {
            title: t('item_type'),
            isSorting: true,
            key: 'typeName',
            placeHolder: t('item_type'),
            width: 250
        },
        {
            title: t('item_group'),
            isSorting: true,
            key: 'categoryName',
            placeHolder: t('item_group'),
            width: 250
        },
        {
            title: t('location'),
            isSorting: true,
            key: 'locationName',
            placeHolder: t('actualLocation'),
            width: 250,
            render: (text, record) => (
                <div>
                    <span>{text}</span>
                    {record.locationName !== record.actualLocationName && (
                        <Tooltip title={record.actualLocationName}>
                            <span style={{ color: 'red', marginLeft: 8, cursor: 'pointer' }}>⚠️</span>
                        </Tooltip>
                    )}
                </div>
            ),
        },
        {
            title: t('inventory_status_name'),
            isSorting: true,
            key: 'inventoryStatusName',
            placeHolder: t('inventory_status_name'),
            width: 250
        },
    ];

    const columns1: IMUIDataGridColumns[] = [
        {
            title: t('inventoryName'),
            headerAlign: 'center',
            align: 'left',
            key: 'inventoryName',
            placeHolder: t('inventoryName'),
            width: 485,
            render: (text, record) => record?.inventoryTBL?.inventoryName
        },
        {
            title: t('barcode'),
            isSorting: true,
            key: 'barcode',
            placeHolder: t('barcode'),
            width: 490,
            render: (text, record) => record?.inventoryTBL?.barcode
        },
        {
            title: t('operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            isSorting: true,
            render: (order, record) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <Space>
                        <Popconfirm
                            title={t('confirm_delete')}
                            onConfirm={() => handleDeleteItem(record.inventoryId)}
                            okText={t('yes')}
                            cancelText={t('no')}
                        >
                            <Tooltip title={t('delete')} placement="top">
                                <Button
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    style={{
                                        display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                                        width: '60px',
                                        borderRadius: '70px'
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </Tooltip>
                        </Popconfirm>
                    </Space>
                </div>
            ),
        }
    ];

    const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
        return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
    };

    const InventoryFilter = (e?) => {
        const filters = e?.filters;
        const isSorting = e?.sortField !== undefined;
        const body = {
            sortColumn: e?.sortField || '',
            sortOrder: e?.sortOrder || 'asc',
            pageSize: e?.pageSize || 10,
            page: isSorting ? 1 : (e?.page || 1),
            barcode: filters?.barcode,
            customBarcode: filters?.barcode,
            departmentName: filters?.departmentName,
            inventoryName: filters?.inventoryName,
            inventoryStatusName: filters?.inventoryStatusName,
            typeName: filters?.typeName,
            debtFirstName: filters?.debtFirstName,
            debtLastName: filters?.debtLastName,
            companyId: e?.companyId,
            companyName: filters?.companyName,
            itemName: filters?.itemName,
            itemGroup: e?.itemGroup,
            locationName: filters?.locationName,
            categoryName: filters?.categoryName,
            debbit: e?.debbit,
            responsible: e?.responsible,
            isPrinted: e?.isPrinted,
        };

        HTTPService.POST(`/Inventory/filters`, body).then((response) => {
            if (response.status === 200 && response.data) {
                setInventoryData(response.data);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: response.data,
                    life: 3000
                });
            }
        });
    };


    const handleAddSelectedItems = () => {
        if (!selectedItems || selectedItems.length === 0) {
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: t('anyInventory'),
                life: 3000
            });
            return;
        }

        const selectedItem = selectedItems[0];

        const newRepeatMaintenanceTBL = [{
            inventoryId: selectedItem.inventoryId,
            inventoryTBL: {
                inventoryName: selectedItem.inventoryName,
                barcode: selectedItem.barcode || selectedItem.customBarcode
            }
        }];

        setCareData({
            ...careData,
            repeatMaintenanceTBL: newRepeatMaintenanceTBL,
            count: 1
        });

        setSelectedItems([]);

        toast.current?.show({
            severity: 'success',
            summary: t('success'),
            detail: t('assetAdd'),
            life: 3000
        });
    };

    const handleRowSelection = (selectedRowsData: any[]) => {
        setSelectedItems(selectedRowsData);
    };

    const handleDeleteItem = (inventoryId: number) => {
        const updatedRepeatMaintenanceTBL = careData?.repeatMaintenanceTBL.filter(
            item => item.inventoryId !== inventoryId
        );

        setCareData({
            ...careData,
            repeatMaintenanceTBL: updatedRepeatMaintenanceTBL
        });

        toast.current?.show({
            severity: 'success',
            summary: t('success'),
            detail: t('inventory_delete'),
            life: 3000
        });
    };


    const registerFault = (formData) => {
        try {
            const faultData = {
                inventoryId: careData?.repeatMaintenanceTBL?.[0]?.inventoryId || 0,
                activityId: formData.activityId,
                description: formData.description,
                maintenanceResponsibleUserId: formData.maintenanceResponsibleUserId,
                maintenanceExternalResponsibleName: formData.maintenanceExternalResponsibleName,
                maintenanceExternalResponsibleMail: formData.maintenanceExternalResponsibleMail,
                maintenanceCreatedUserId: userInfo?.userId,
                priority: Number(formData.Priority),
                maintenanceStartDate: moment().format("YYYY-MM-DDTHH:mm:ss")
            };
            HTTPService.POST(`/Maintenance/registerFaultRecord`, faultData)
                .then((res) => {
                    if (res.status === 200) {
                        toast.current?.show({
                            severity: 'success',
                            summary: t('success'),
                            detail: t('maintenanceCreated'),
                            life: 3000
                        });
                        window.location.replace("/admin/fault-management/");
                    } else {
                        toast.current?.show({
                            severity: 'error',
                            summary: t('errors'),
                            detail: t(res.data),
                            life: 3000
                        });
                    }
                })
                .catch((error) => {
                    console.error('Save Error:', error);
                    const errorMessage = error?.response?.data?.title || t('save_failed');
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: errorMessage,
                        life: 3000
                    });
                });
        } catch (error) {
            console.error('Form processing error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('save_failed'),
                life: 3000
            });
        }
    };


    const handleCancelFault = () => {
        setIsModalVisibleFault(false);
    };

    const handleCancel = () => {
        window.location.replace("/admin/care-management/");
    };

    const showModal = () => {
        setIsModalVisible(true);
        InventoryFilter();
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
    };

    const fetchActivity = async (companyId: number) => {
        try {
            const result = await HTTPService.GETActivityNames(companyId);
            const faultActivities = result.filter(activity => activity.maintenanceType === 2);
            setActivityData(faultActivities);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };


    const handleChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };

    const getMaintenanceTypeValue = (maintenanceType: number) => {
        return maintenanceType === 1 ? 1 : 2;
    };

    const getRepeatActivityValue = (repeatMaintenance?: number) => {
        if (repeatMaintenance === undefined || repeatMaintenance === null) {
            return undefined;
        }

        switch (repeatMaintenance) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 7:
                return 7;
            case 30:
                return 30;
            case 365:
                return 365;
            case -1:
                return 'Custom';
            default:
                return undefined;
        }
    };

    const showModalFault = () => {
        setIsModalVisibleFault(true);
    };


    return (
        <>
            <Toast ref={toast} />
            <Form
                layout="vertical"
                onFinish={registerFault}
                form={form}
                fields={
                    maintenanceId && parseInt(maintenanceId) !== 0
                        ? [
                            {
                                name: ["activityId"],
                                value: careData?.activityId
                            },
                            { name: ["description"], value: careData?.description },
                            { name: ["priority"], value: careData?.priority },
                            { name: ["maintenanceResponsible"], value: careData?.maintenanceResponsible },
                            { name: ["maintenanceStartDate"], value: careData?.maintenanceStartDate ? moment(careData?.maintenanceStartDate) : undefined },
                            { name: ["maintenanceFinishDate"], value: careData?.maintenanceFinishDate ? moment(careData?.maintenanceFinishDate) : undefined },
                            {
                                name: ["repeatActivity"],
                                value: selectedActivityType !== undefined
                                    ? getRepeatActivityValue(selectedActivityType)
                                    : undefined
                            },
                            { name: ["maintenanceType"], value: getMaintenanceTypeValue(careData?.maintenanceType) }
                        ]
                        : []
                }
            >
                <Card style={{ padding: "50px" }}>

                    <Box>
                        {userInfo?.role === UserRole.AltisAdmin ? (
                            <Form.Item
                                name="companyId"
                                label={t('Select company')}
                                rules={[{ required: true, message: t('please_select_a_company') }]}
                                initialValue={selectedCompany}
                            >
                                <Select
                                    showSearch
                                    placeholder={t('company_name')}
                                    style={{ marginBottom: '6px' }}
                                    filterOption={filterOption}
                                    onChange={(value) => {
                                        setSelectedCompany(value);
                                        fetchActivity(value);
                                    }}
                                >
                                    {companyData?.map((company) => (
                                        <Select.Option key={company.companyId} value={company.companyId}>
                                            {company.companyName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : (
                            <Form.Item
                                name="companyId"
                                initialValue={userInfo?.companyId}
                                hidden
                            >
                                <Input type="hidden" />
                            </Form.Item>
                        )}

                        <Form.Item
                            name='activityId'
                            label={
                                <Tooltip title={t('fault_Code')}>
                                    {t('fault_Code')}
                                </Tooltip>
                            }
                            rules={[{ required: true, message: t('fault_Code') }]}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Select
                                    placeholder={t('fault_Code')}
                                    style={{ flex: 1 }}
                                    dropdownStyle={{ minWidth: 300 }}
                                    filterOption={filterOption}
                                    showSearch
                                    value={selectedActivity}
                                    onChange={(value) => {
                                        setSelectedActivity(value);
                                        form.setFieldsValue({ activityId: value });
                                    }}
                                >
                                    {activityData?.map(row => (
                                        <Select.Option key={row.activityId} value={row.activityId}>
                                            {row.activityName}
                                        </Select.Option>
                                    ))}
                                </Select>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={showModalFault}
                                />
                            </div>
                        </Form.Item>

                        <Modal
                            visible={isModalVisibleFault}
                            footer={null}
                            onCancel={handleCancelFault}
                            width={790}
                            bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
                        >
                            <div style={{ flex: 1 }}>
                                <AddActivityName
                                    cancelModal={handleCancelFault}
                                    savedObj={savedNewFault}
                                    companyId={selectedCompany}
                                    activityName={careData?.activityName}
                                    onSetPage={props.onSetPage}
                                    getPageData={props.getPageData}
                                    maintenanceType={2} // Arıza kaydı için maintenanceType 2 olarak eklendi
                                />
                            </div>
                        </Modal>

                        {maintenanceType == 1 && (
                            <>
                                <Form.Item
                                    label={t('activity_start_date')}
                                    name="maintenanceStartDate"
                                    rules={[{ required: true, message: t('select_date_time') }]}
                                >
                                    <DatePicker
                                        showTime
                                        format="DD-MM-YYYY HH:mm"
                                        placeholder={t('select_date_time')}
                                        style={{ borderRadius: '5px', width: '100%' }} />
                                </Form.Item>
                            </>
                        )}
                        {/* 
                            <Form.Item
                                label={t('estimatedCompletion')}
                                name="maintenanceFinishDate"
                                rules={[{ required: true, message: t('estimatedCompletion'), pattern: /^[0-9]*$/ }]}
                            >
                                <Input min={0} placeholder={t('estimatedCompletion')} style={{ borderRadius: '5px' }} />
                            </Form.Item> */}

                        <Form.Item
                            name="Priority"
                            label={t('Priority')}
                            rules={[{ required: true, message: t('Priority') }]}
                        >
                            <Select
                                placeholder={t('Priority')}
                                style={{ marginBottom: '6px' }}
                            >
                                <Select.Option value={0}>{t('Low')}</Select.Option>
                                <Select.Option value={1}>{t('Medium')}</Select.Option>
                                <Select.Option value={2}>{t('High')}</Select.Option>
                                <Select.Option value={3}>{t('Highest')}</Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label={t('description_activity')}
                            name="description"
                            rules={[{ required: true, message: t('enter_description') }]}
                        >
                            <Input placeholder={t('enter_description')} style={{ borderRadius: '5px' }} />
                        </Form.Item>


                        <Form.Item
                            label={t('faultResponsible')}
                            name="maintenanceExternalResponsibleName"
                            rules={[{ required: true, message: t('faultResponsible') }]}
                        >
                            <Dropdown
                                placeholder={t('faultResponsible')}
                                dataSource={userData}
                                allowCustomValue={true}
                                valueKey="displayName"
                                style={{ width: '100%' }}
                                includeEmptyOption={false}
                                labelKey="displayName"
                                onChange={(value) => {
                                    const selectedUser = userData?.find(u => u.displayName === value || u.userId === value);
                                    form.setFieldsValue({
                                        maintenanceExternalResponsibleName: selectedUser ? selectedUser.displayName : value,
                                        maintenanceResponsibleUserId: selectedUser ? selectedUser.userId : null,
                                        maintenanceExternalResponsibleMail: selectedUser?.userEmail || undefined
                                    });
                                }}
                            />
                        </Form.Item>

                        <Form.Item name="maintenanceResponsibleUserId" hidden>
                            <Input type="hidden" />
                        </Form.Item>

                        <Form.Item
                            label={t('email')}
                            name="maintenanceExternalResponsibleMail"
                            rules={[{ required: true }]}
                        >
                            <Dropdown
                                placeholder={t('email')}
                                dataSource={userData}
                                valueKey="userEmail"
                                labelKey="userEmail"
                                style={{ width: '100%' }}
                                includeEmptyOption={false}
                                allowCustomValue={true}
                            />
                        </Form.Item>

                        {maintenanceType === 1 && (
                            <>
                                <Form.Item
                                    name='repeatActivity'
                                    label={t('repeat_activity')}
                                    rules={[{ required: true, message: t('repeat_activity') }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t('repeat_activity')}
                                        onChange={(value) => {
                                            setSelectedActivityType(value);
                                            setShowCustomFrequency(value === 'Custom');
                                        }}
                                    >
                                        <Select.Option value={0}>{t('onetime')}</Select.Option>
                                        <Select.Option value={1}>{t('daily')}</Select.Option>
                                        <Select.Option value={7}>{t('weekly')}</Select.Option>
                                        <Select.Option value={30}>{t('monthly')}</Select.Option>
                                        <Select.Option value={365}>{t('yearly')}</Select.Option>
                                        <Select.Option value="Custom">{t('custom')}</Select.Option>
                                    </Select>
                                </Form.Item>

                                {showCustomFrequency && (
                                    <Form.Item
                                        name="frequency"
                                        label={t('frequency_days')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('frequency_days')
                                            },
                                            {
                                                pattern: /^[0-9]*$/,
                                                message: t('please_enter_valid_number')
                                            }
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('frequency_days')}
                                            style={{ borderRadius: '5px' }}
                                            type="number"
                                            min={1}
                                        />
                                    </Form.Item>
                                )}
                            </>
                        )}

                        <Button
                            onClick={showModal}
                            type="primary"
                            style={{ marginTop: 10, marginRight: 10, borderRadius: '5px' }}
                            icon={<UnorderedListOutlined />}
                        >
                            {t('first_datagrid')}
                        </Button>

                        <Modal
                            title={t('first_datagrid')}
                            visible={isModalVisible}
                            onCancel={handleModalCancel}
                            width={1200}
                            footer={[
                                <Button
                                    key="add"
                                    type="primary"
                                    onClick={() => {
                                        handleAddSelectedItems();
                                        handleModalCancel();
                                    }}
                                >
                                    {t('add_selected_items')}
                                </Button>
                            ]}
                        >
                            <MUIDatagrid
                                data={inventoryData?.data}
                                columns={columns}
                                enableSelection={true}
                                singleSelection={true}
                                onSelectionChange={handleRowSelection}
                                onChange={InventoryFilter}
                                total={inventoryData?.count}
                                defaultPageSize={10}
                                filterMode="server"
                            />
                        </Modal>

                        <MUIDatagrid
                            data={careData?.repeatMaintenanceTBL}
                            columns={columns1}
                            onChange={InventoryFilter}
                            total={careData?.count}
                        />

                        <Form.Item>
                            <Row gutter={[4, 4]} justify="end" align="middle">
                                <Col xs={12} sm={4}>
                                    <Button
                                        block
                                        onClick={handleCancel}
                                        type="primary"
                                        style={{
                                            height: 64,
                                            backgroundColor: 'transparent',
                                            color: '#1890ff',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0 10px',
                                            border: 'none',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                            e.currentTarget.style.color = '#40a9ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = 'none';
                                            e.currentTarget.style.color = '#1890ff';
                                        }}
                                    >
                                        <CloseOutlined style={{ fontSize: 20 }} />
                                        <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                            {t('cancel')}
                                        </span>
                                    </Button>
                                </Col>
                                <Col xs={12} sm={4}>
                                    <Button
                                        block
                                        htmlType="submit"
                                        type="primary"
                                        style={{
                                            height: 64,
                                            backgroundColor: 'transparent',
                                            color: '#1890ff',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0 10px',
                                            border: 'none',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                            e.currentTarget.style.color = '#40a9ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = 'none';
                                            e.currentTarget.style.color = '#1890ff';
                                        }}
                                    >
                                        <SaveOutlined style={{ fontSize: 20 }} />
                                        <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                            {t('save')}
                                        </span>
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Item>
                    </Box>
                </Card>
            </Form>
        </>
    );
};

export default AddFault;
